"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHashData = exports.formatHashData = void 0;
const separator = "_";
function formatHashData({ commitId, hash }) {
    return `${commitId}${separator}${hash}`;
}
exports.formatHashData = formatHashData;
function parseHashData(data) {
    const [rawCommitId, ...hash] = data.split(separator);
    const commitId = parseInt(rawCommitId);
    if (!hash || !commitId || Number.isNaN(commitId)) {
        return null;
    }
    return { commitId, hash: hash.join(separator) };
}
exports.parseHashData = parseHashData;
//# sourceMappingURL=hashDataEncoding.js.map